export const DEFAULT_QUERY_LIMIT = 1000;
